import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    ButtonBase,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import Apis from '../../network/Apis';
import AppUtils from '../../control/apputlis'; 

const ICON_EXAHNGE = require("../../images/icons/exchange_succes.png");


class IntegralExchange extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
        };
    }

    componentDidMount() {
        this.encryptionHostLive();
        AppUtils.YMPush('MAIN', 'ShopMall');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    encryptionHostLive = async () => {
        let result = await Apis.encryptionHostLive();
        if (result.code == 200) {
            this.setState({ data: result.data });
        }
    }

    onClickContinue = () => {
        window.history.back();
    } 

    onClickMyGoods = () => {
        let { channel, uid, token, nav } = this.props.match.params;
        this.props.history.push({ pathname: '/integralgoods/' + channel + '/' + uid + "/" + token + "/" + nav });
    }

    render() {
        const { classes } = this.props;
        const { data } = this.state;
        let { nav, score, total } = this.props.match.params;
        return ( 
            <MBack title='积分商城' backgroundColor="#FFF" hideNav={nav}>
                <Grid container direction='row' alignItems='center' className={classes.myInfo}>
                    <Grid container direction='column' alignItems='center' justifyContent='center'>
                        <img src={ICON_EXAHNGE} style={{ width: 78, height: 96, marginTop: 24 }} />
                        <Typography style={{ fontSize: 17, color: "#2F2F2F", marginTop: 24, fontWeight: 'bold' }}>恭喜你兑换成功</Typography>
                    </Grid>
                    <Grid container direction='row' alignItems='center' justifyContent='center' style={{ marginTop: 32 }}>
                        <Grid container direction='column' alignItems='center' style={{ flex: 1 }} >
                            <Typography style={{ fontSize: 17, color: '#2F2F2F' }}>{score}</Typography>
                            <Typography style={{ fontSize: 12, color: '#919191' }}>已兑换积分</Typography>
                        </Grid>
                        <Grid style={{ width: 1, backgroundColor: '#E2E2E2', height: 30 }} />
                        <Grid container direction='column' alignItems='center' style={{ flex: 1 }}>
                            <Typography style={{ fontSize: 17, color: '#2F2F2F' }}>{total}</Typography>
                            <Typography style={{ fontSize: 12, color: '#919191' }}>剩余积分</Typography>
                        </Grid>
                    </Grid>
                    <Grid container direction='row' alignItems='center' justifyContent='center' style={{ marginTop: 32 }}>
                        <Grid container direction='column' alignItems='center' style={{ flex: 1 }} >
                            <ButtonBase onClick={() => this.onClickContinue()} className={classes.continueExchange}>继续兑换</ButtonBase>
                        </Grid>
                        <Grid container direction='column' alignItems='center' style={{ flex: 1 }} >
                            <ButtonBase onClick={() => this.onClickMyGoods()} className={classes.lookGoods}>查看我兑换的商品</ButtonBase>
                        </Grid>
                    </Grid>
                    <Grid container direction='row' alignItems='center' justifyContent='center' style={{ marginTop: 16, paddingLeft: 12, paddingRight: 12 }}>
                        <Typography style={{ fontSize: 12, color: '#919191' }}>* 请在兑换的商品里完善好自己的收货地址，工作人员确认过后 会自动发货，因系统原因，无法提供物流信息；</Typography>
                    </Grid>
                </Grid>
            </MBack >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    myInfo: {
        paddingTop: 36,
        paddingBottom: 24,
        paddingRight: 12,
        paddingLeft: 12
    },
    continueExchange: {
        border: 'solid 1px #1BB0A4',
        fontSize: 14,
        color: '#18ABAC',
        width: '40vw',
        height: 40,
        borderRadius: 10,
    },
    lookGoods: {
        background: '#007AFF',
        fontSize: 14,
        color: '#FFFFFF',
        width: '40vw',
        height: 40,
        borderRadius: 10,
    }
}))(IntegralExchange));